function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * @method entityReducerFactory
 * Base functionality for working with lists of table data.
 */
import _ from 'underscore';
import selectReducerFactory from './selectReducerFactory';
import { constantsRegistry } from '../../constants/tableConstantsFactory';
import { reduceReducers, setEntities } from '../applyReducer';

// REDUCER METHODS
const index = state => _objectSpread(_objectSpread({}, state), {}, {
  loading: true,
  totalCount: null
});
const indexSuccess = (state, action) => {
  const {
    query
  } = action;
  const data = _.clone(action.data);
  let hasNext = false;
  let hasPrevious = false;
  if (query.paging) {
    hasPrevious = query.paging.current > 0;
    const extraIDs = (query.alwaysIncluded || []).length;

    // the server signifies that a next page exists by returning an extra row at the end
    hasNext = query.paging.size < action.data.length - extraIDs;

    // pop the extra row off for display
    if (hasNext) {
      data.pop();
    }
  }
  return _objectSpread(_objectSpread(_objectSpread({}, state), setEntities(state, data)), {}, {
    // sets list
    error: null,
    hasNext,
    hasPrevious,
    indexQuery: query,
    loading: false
  });
};
const indexFail = (state, action) => _objectSpread(_objectSpread({}, state), {}, {
  active: {},
  error: action.payload ? action.payload : {
    message: 'failed fetching index'
  },
  loading: false
});
export default function entityReducerFactory(entity) {
  const constants = constantsRegistry(entity);
  const selectReducers = selectReducerFactory(entity);
  const defaultIndexQuery = {
    filters: {},
    initialized: false,
    paging: {
      current: 0,
      size: 20
    },
    // these are used for setting query filters for the next time the query is run. This allows
    // unrelated reducers to set filters in state without needing to trigger a serverIndex
    pendingFilters: null,
    sortAttribute: null,
    sortDirection: 'ASC'
  };
  const filterClear = state => _objectSpread(_objectSpread({}, state), {}, {
    indexQuery: JSON.parse(JSON.stringify(defaultIndexQuery)),
    initialIndexQuery: JSON.parse(JSON.stringify(defaultIndexQuery))
  });
  const initState = _objectSpread({
    entity,
    hasPrevious: false,
    hasNext: false,
    indexQuery: JSON.parse(JSON.stringify(defaultIndexQuery)),
    initialIndexQuery: JSON.parse(JSON.stringify(defaultIndexQuery)),
    loading: false,
    list: [],
    /** Filtered total (cabinet: SET via INDEX_COUNT_SUCCESS) */
    totalCount: null,
    sectionIndex: null
  }, selectReducers.initState);

  // used to clean up dirty state made by serverIndex
  const indexCancel = state => _objectSpread(_objectSpread({}, state), {}, {
    list: [],
    indexQuery: defaultIndexQuery
  });
  const reducers = _objectSpread(_objectSpread({
    [constants.FILTER_CLEAR]: filterClear,
    [constants.INDEX]: index,
    [constants.INDEX_CANCEL]: indexCancel,
    [constants.INDEX_FAIL]: indexFail
  }, selectReducers.reducers), {}, {
    [constants.INDEX_SUCCESS]: reduceReducers(indexSuccess, selectReducers.reducers[constants.INDEX_SUCCESS])
  });

  // note that the returned object is intended for composition and client code will need to call
  // `applyReducers(reducers, state)` to get an expected redux reducer
  return {
    reducers,
    initState
  };
}